import { makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles(() => ({
  input: {
    padding: '11px 15px 9px',
  },
}));
